import * as React from "react"

//文字列が数値化どうかチェック
export const isNaNModified = (inputStr: string) => {
  var numericRepr = parseFloat(inputStr);
  return isNaN(numericRepr) || numericRepr.toString().length != inputStr.length;
}